module.exports = __webpack_public_path__ + "img/Icon_AddressBookBtn.c16ce1ef.png";